import { BaseService } from "./BaseService";
import { PlansInput, PlansOutput } from "@/interfaces/plan";

export class PlansService extends BaseService<
PlansInput,
PlansOutput
> {
  constructor() {
    super();
    this.path = "plans";
  }
}
